// helpers/rutaEstaciones.js
import axios from "axios";

const RAW_BASE_URL =
  import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";

const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");
const API = axios.create({ baseURL: BASE_URL });

const p = (s) => String(s || "").replace(/^\/+/, "");

const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// ---- ESTACIONES / PROVEEDORES DE COMBUSTIBLE ----

export const getEstaciones = async () => {
  const { data } = await API.get(p("estaciones"), auth());
  return data;
};

export const getEstacionById = async (id) => {
  const { data } = await API.get(p(`estaciones/${id}`), auth());
  return data;
};

export const postEstacion = async (payload) => {
  const { data } = await API.post(p("estaciones"), payload, auth());
  return data;
};

export const putEstacion = async (id, payload) => {
  const { data } = await API.put(p(`estaciones/${id}`), payload, auth());
  return data;
};

export const deleteEstacion = async (id) => {
  const { data } = await API.delete(p(`estaciones/${id}`), auth());
  return data;
};